export default {
  Unknown: 'Unknown',
  AccountLinked: 'AccountLinked',
  AccountNotLinked: 'AccountNotLinked',
  AccountNotFound: 'AccountNotFound',
};
